export const searchPageSize = 6;
export const revalidateTimeout = 600;
export const homeTitle = "Home";
export const unitLimitQuantity = 10;
export const unitLimitTag = "unit-limit";
export const unitLimitQuery = `tag:${unitLimitTag}`;
export const pageLimit = 9;
export const searchLimit = 3;
export const headerHeight = 120;
export const highlightedPageLimit = 5;
export const relatedRecipePageLimit = 6;